import { useEffect } from "react";

const useGoogleTranslateDetect = () => {
  useEffect(() => {
    const save = () => {
      const lang = document.documentElement.lang || navigator.language;
      localStorage.setItem("browserLanguage", lang);
    };

    save(); // capture on mount

    // Chrome built-in translation changes the <html lang=""> attribute
    const observer = new MutationObserver(save);
    observer.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ["lang"],
    });

    return () => observer.disconnect();
  }, []);
};

export default useGoogleTranslateDetect;
